<template>
  <div
    class="auth-login-logo"
    data-testid="auth-login-logo"
  >
    <span class="auth-login-logo__stack">
      <span class="auth-login-logo__mark-wrap">
        <img
          class="auth-login-logo__mark"
          src="/img/auth/panel/logo-mark.svg"
          :alt="alt"
          data-testid="auth-login-logo__mark"
        />
      </span>
      <img
        class="auth-login-logo__wordmark"
        src="/img/auth/panel/logo-wordmark.svg"
        alt=""
        data-testid="auth-login-logo__wordmark"
      />
    </span>
  </div>
</template>

<script>
import constants from '../../../plugins/constants';

const { AUTH } = constants;

export default {
  name: 'AuthLoginLogo',
  props: {
    alt: { type: String, default: AUTH.LOGO_ALT },
  },
};
</script>

<style lang="scss" scoped>
@import './AuthLoginLogo.scss';
</style>
